import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminDeleteUser, useBlockUser, useGetUsers, useSetAdmin, useSetGarde } from "../../shared/services/utilisateurs/user.service";
import { message, Table, Button, Popconfirm, Space } from "antd";
import Card from "antd/es/card/Card";
import { ResponseUser } from "../../shared/types/response/responseuser.model";
import type { TableProps } from 'antd';
import { Grid } from "antd";

const ListeUsers: FC = () => {

    const navigate = useNavigate();

    //Active le scoll sur la table seulement pour téléphone
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();

    const[messageApi, contextHolder] = message.useMessage();
    const[idRequestGarde, setIdRequestGarde] = useState<number>();
    const[idRequestAdmin, setIdRequestAdmin] = useState<number>();
    const[idRequestBlock, setIdRequestBlock] = useState<number>();
    const[idRequestSuppr, setIdRequestSuppr] = useState<number>();
    const[dataTable, setDataTable] = useState<ResponseUser[]>([]);
    
    const {dataUser, errorUser} = useGetUsers();
    const {dataAdmin, errorAdmin} = useSetAdmin(idRequestAdmin);
    const {dataGarde, errorGarde} = useSetGarde(idRequestGarde);
    const {dataBlockUser, errorBlockUser} = useBlockUser(idRequestBlock);
    const {dataSupprUser, errorSupprUser} = useAdminDeleteUser(idRequestSuppr);

    useEffect(() => {
        if(errorUser){
            navigate("/espaceuser");
        }
    }, [errorUser])

    useEffect(() =>{
        if(dataUser){
            setDataTable(dataUser);
        }
    }, [dataUser])

    useEffect(() =>{
        if(errorAdmin && errorAdmin.response.data.erreur){
            messageApi.error(errorAdmin.response.data.erreur);
        }else{
            if(errorAdmin)
            {
                messageApi.error(errorAdmin.message);
            }
        }
    }, [errorAdmin])

    useEffect(() => {
        if(dataAdmin && dataAdmin.ok){
            messageApi.success(dataAdmin.ok);
            const updateTable = dataTable.map(item =>
                item.id === idRequestAdmin ?
                    {
                        ...item,
                        roles : item.roles.some(r => r.role === "ADMIN")
                            ? item.roles.filter(r => r.role !== "ADMIN")
                            : [...item.roles, {role : "ADMIN"}]
                    } : item
            );
            setDataTable(updateTable);
            setIdRequestAdmin(undefined);
        }
    }, [dataAdmin])

        useEffect(() =>{
        if(errorGarde && errorGarde.response.data.erreur){
            messageApi.error(errorGarde.response.data.erreur);
        }else{
            if(errorGarde)
            {
                messageApi.error(errorGarde.message);
            }
        }
    }, [errorGarde])

    useEffect(() => {
        if(dataGarde && dataGarde.ok){
            messageApi.success(dataGarde.ok);
            const updateTable = dataTable.map(item =>
                item.id === idRequestGarde ?
                    {
                        ...item,
                        roles : item.roles.some(r => r.role === "GARDE")
                            ? item.roles.filter(r => r.role !== "GARDE")
                            : [...item.roles, {role : "GARDE"}]
                    } : item
            );
            setDataTable(updateTable);
            setIdRequestGarde(undefined);
        }
    }, [dataGarde])

    useEffect(() =>{
        if(errorBlockUser && errorBlockUser.response.data.erreur){
            messageApi.error(errorBlockUser.response.data.erreur);
        }else{
            if(errorBlockUser)
            {
                messageApi.error(errorBlockUser.message);
            }
        }
    }, [errorBlockUser])

    useEffect(() =>{
        if(errorSupprUser && errorSupprUser.response.data.erreur){
            messageApi.error(errorSupprUser.response.data.erreur);
        }else{
            if(errorSupprUser)
            {
                messageApi.error(errorSupprUser.message);
            }
        }
    }, [errorSupprUser])

    useEffect(() => {
        if(dataSupprUser && dataSupprUser.ok){
            messageApi.success(dataSupprUser.ok);
            setDataTable(prev => prev.filter(user => user.id!==idRequestSuppr));
            setIdRequestSuppr(undefined);
        }
    }, [dataSupprUser])

    useEffect(() => {
        if(dataBlockUser && dataBlockUser.ok){
            messageApi.success(dataBlockUser.ok);
            const updateTable = dataTable.map(item =>
                item.id === idRequestBlock ? {...item, bloquer: !item.bloquer} : item
            );
            setDataTable(updateTable);
            setIdRequestBlock(undefined);
        }
    }, [dataBlockUser])

    function retourEspaceUser(){
        navigate("/espaceuser")
    }

    const shadowCard: React.CSSProperties = {
        boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        width: "100%"
    }

    const columns: TableProps<ResponseUser>['columns'] = [
        {
            title: 'Nom',
            key: 'nom',
            defaultSortOrder: 'ascend',
            sorter: (a, b) =>
                a.identiteUser.nom.localeCompare(b.identiteUser.nom),
            render: (_, r) => r.identiteUser.nom,
        },
        {
            title: 'Prénom',
            key: 'prenom',
            render: (_, r) => r.identiteUser.prenom,
        },
        {
            title: 'utilisateur',
            key: 'username',
            render: (_, r) => r.username,
        },
        {
            title: 'Bloqué ?',
            key: 'bloquer',
            defaultSortOrder: 'descend',
            render: (_, r) => r.bloquer ? "Oui" : "Non",
        },
        {
            title: 'Date Naissance',
            key: 'naissance',
            render: (_, r) => r.identiteUser.naissance,
        },
        {
            title: 'Mail',
            key: 'mail',
            render: (_, r) => r.identiteUser.mail,
        },
        {
            title: 'Téléphone',
            key: 'telephone',
            render: (_, r) => r.identiteUser.telephone,
        },
        {
            title: 'Adresse',
            key: 'adresse',
            render: (_, r) => `${r.identiteUser.adresse.numVoie} ${r.identiteUser.adresse.nomVoie} ${r.identiteUser.adresse.codePostal} ${r.identiteUser.adresse.ville}`,
        },
        {
            title: 'Roles',
            key: 'roles',
            render: (_, r) => r.roles.map(r => r.role).join(","),
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, r) => (
                <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                    <Popconfirm
                        title="Mettre/Retirer Dirigeant"
                        description="Etes-vous sûr de mettre cet utilisateur en role dirigeant (ADMIN) ?"
                        onConfirm={() => setIdRequestAdmin(r.id)}
                        okText="Oui"
                        cancelText="Non"
                    >
                        <Button type="primary">Mettre/Retirer dirigeant</Button>
                    </Popconfirm>

                    <Popconfirm
                        title="Mettre/Retirer Garde-Pêche"
                        description="Etes-vous sûr de mettre cet utilisateur en role de garde-pêche ?"
                        onConfirm={() => setIdRequestGarde(r.id)}
                        okText="Oui"
                        cancelText="Non"
                    >
                        <Button type="primary">Mettre/Retirer Garde-Pêche</Button>
                    </Popconfirm>

                    <Popconfirm
                        title="Bloquer/Débloquer utilisateur"
                        description="Etes-vous sûr de bloquer ou débloquer cet utilisateur ?"
                        onConfirm={() => setIdRequestBlock(r.id)}
                        okText="Oui"
                        cancelText="Non"
                    >
                        <Button type="primary">Bloquer/Débloquer utilisateur</Button>
                    </Popconfirm>

                    <Popconfirm
                        title="Supprimer utilisateur"
                        description="Etes-vous sûr de supprimer cet utilisateur ?"
                        onConfirm={() => setIdRequestSuppr(r.id)}
                        okText="Oui"
                        cancelText="Non"
                    >
                        <Button type="primary" style={{backgroundColor: "red"}}>Supprimer utilisateur</Button>
                    </Popconfirm>
                </Space>
            )
        }
    ];

    return(
        <div className="full-left">
            <Card title={<span style={{ textAlign: "center" }}>Liste des utilisateurs</span>} variant="borderless" style={shadowCard}>
                {contextHolder}
                <Table<ResponseUser> columns={columns} dataSource={dataTable} rowKey="id" scroll={!screens.md ? { x: "max-content" } : undefined}  />
                <Button onClick={retourEspaceUser} style={{ marginTop: "24px" }}>Retour</Button>
            </Card>
        </div>
    )
}

export default ListeUsers;